import styles from './PatientFilterChip.module.scss';
import { Icon, Text } from 'components';
import { getUsers } from 'store/users/selectors';
import { useSelector } from 'store/utils';

type Props = {
  onClick(): void;
  label?: string;
};
export const PatientFilterChip = ({ label, onClick }: Props) => {
  const users = useSelector(getUsers);

  return (
    <div className={styles.wrapper} onClick={onClick}>
      <Text type="overline">{label}</Text>
      <Icon name="Close" className={styles.icon} />
    </div>
  );
};
